'use es6';

import { search } from './dao';
import { generate } from './generate';
import { transform } from './transform';
export default ((spec, config) => generate(config, spec.properties.idProperty).then(payload => search(spec.search.url, payload)).then(response => transform(config, spec, response)));